export enum NoteColumnsEnum {
  Note = 'note',
  CostCenterName = 'costCenterName',
  CostCenterNumber = 'costCenterNumber',
  PersonNR = 'personNR',
  LastName = 'lastName',
  FirstName = 'firstName',
  DateTimeEntry = 'dateTimeEntry',
}
